import React from "react";

import AgGrid from "components/AgGrid/AgGrid";
import TableWrapper from "components/AgGrid/TableWrapper";

const DEFAULT_COLUMN_DEFINITION = {
  sortable: true,
  resizable: true,
  suppressKeyboardEvent: params => params.editing,
};

export const BaseTable = ({
  columns,
  context,
  data,
  onCellValueChanged,
  onGridReady,
  onCellEditRequest,
  getRowId,
  defaultColDefOverride = {},
  immutableData,
  readOnlyEdit,
  getContextMenuItems = undefined,
}) => {
  return (
    <TableWrapper>
      <AgGrid
        rowData={data}
        pagination
        paginationPageSize={400}
        columnDefs={columns}
        defaultColDef={{
          ...DEFAULT_COLUMN_DEFINITION,
          ...defaultColDefOverride,
        }}
        getRowId={getRowId}
        immutableData={immutableData}
        onCellEditRequest={onCellEditRequest}
        onCellValueChanged={onCellValueChanged}
        onGridReady={onGridReady}
        readOnlyEdit={readOnlyEdit}
        stopEditingWhenCellsLoseFocus
        singleClickEdit
        suppressScrollOnNewData
        context={context}
        getContextMenuItems={getContextMenuItems}
      />
    </TableWrapper>
  );
};
